import { render, staticRenderFns } from "./timetable-main.vue?vue&type=template&id=79ff29e4&lang=pug&"
import script from "./timetable-main.vue?vue&type=script&lang=js&"
export * from "./timetable-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports